<div class="ui-dashboard">

  <div class="dashboard-wrapper">

    <!-- Heading & Dates -->
    <div class="p-b-10">
      <div class="grid grid-gap-20 grid-2x grid-2x-responsive p-b-20">

        <!-- LHS -->
        <div>
          <h2 class="dashboard-head">New Business Dashboard</h2>
          <p class="dashboard-head-sub">
            <!-- <nz-avatar style="color:#f56a00; background-color:#fde3cf; line-height: 0.5"
                       [nzSrc]="'https://randomuser.me/api/portraits/men/73.jpg'" nzSize="small" nzIcon="user">
            </nz-avatar> -->
            <!-- <strong class="p-l-10 p-r-5 d-i-b">Welcome back, {{userName}}!</strong> Here's a quick summary of key data points -->
          </p>
        </div>

        <!-- RHS -->
          <!-- RHS -->
          <div class="text-a-right">
            <!-- <h3><span class="clickable hover-underline color-blue" (click)="navigate()">Inbox</span> / Dashboard</h3> -->
            <!-- Date Range  [nzDisabledDate]="disabledDate"-->
              <nz-range-picker [(ngModel)]="dateRange"  (ngModelChange)="onDashDataChange($event)" class="dash-date-range">
              </nz-range-picker>
            <!-- Color Scheme -->
            <nz-select nzShowSearch  style="display: inline-block; text-align: left; width: 162px; margin-right: 3em;" class="" nzAllowClear nzPlaceHolder="Color Scheme"
                       [(ngModel)]="colorSchemeTempModel" (ngModelChange)="colorSchemeModelChange()">
              <nz-option *ngFor="let z of colorSchemesNames; let i=index;" [nzValue]="i" [nzLabel]="z"></nz-option>
            </nz-select>
          </div>

      </div>
    </div>

    <div>
      <h5 class="d-b p-b-10">
        <!-- Dropdown for selection -->
        <nz-select nzShowSearch nzPlaceHolder="Choose" [(ngModel)]="reportType" style="min-width: 200px;">
          <nz-option nzValue="overall" nzLabel="Overall"></nz-option>
          <nz-option nzValue="Locationwise" nzLabel="Locationwise Pending"></nz-option>
          <nz-option nzValue="Userwise" nzLabel="Userwise Pending"></nz-option>
          <nz-option nzValue="branchWise" nzLabel="Branchwise"></nz-option>
            
          <!-- <nz-option nzValue="STP" nzLabel="STP Summary"></nz-option> -->

        </nz-select>
        <!-- Title -->
        <span class="p-l-10 f-s-1-2r"><span class="text-t-capitalize">{{reportType}}</span> Summary:  {{fromDate | date:'dd MMM yyyy'}} - {{toDate | date:'dd MMM yyyy'}}</span>
      </h5>
    </div>

    <!--------------- STAFF -------------->
    <div *ngFor="let card of dataCARDS">
      <!-- TOP WIDGETS -->
      <div *ngIf="widgetReady && card.key == reportType" class="stat-widgets grid grid-5x grid-gap-20 grid-5x-responsive">
        <div *ngFor="let item of card.subCards let i=index;" class="stat-widget" [ngStyle]="{ 'backgroundColor': colorScheme.domain[i] }">
          <div class="stat-widget-body">
            <strong>{{item.value}}</strong>
            {{item.name }} <br>
          </div>
          <div *ngIf="item.breakup?.length > 0" class="stat-widget-footer">
            <table class="w-100-pc">
              <tr *ngFor="let subItem of item.breakup">
                <td>{{subItem.key}}</td>
                <td class="text-a-right">{{subItem.value}}</td>
                <ng-container *ngFor="let keyValuePair of subItem | keyvalue">
                  <td>{{ keyValuePair.key }}</td>
                  <td class="text-a-right">{{ keyValuePair.value }}</td>
                </ng-container>
              </tr>
            </table>
          </div>
        </div>
      </div>
  </div>
</div>  